import ModalFooter from 'features/shared/components/modal/ModalFooter';
import ModalHeader from 'features/shared/components/modal/ModalHeader';
import FormGroup from 'features/shared/forms/components/FormGroup';
import { useForm } from 'features/shared/forms/hooks/useForm';
import React from 'react';
import { Modal } from 'react-bootstrap';
import PhoneNumberVerificationDTO from 'features/requirements/dtos/PhoneNumberVerificationDTO';
import PromiseLoadingSpinner from 'features/shared/components/loaders/PromiseLoadingSpinner';
import { RequirementDetail_ConfirmMobileDialog } from 'features/shared/components/loaders/promiseLoadingAreas';
import { confirmMobileDialogValidations } from './confirmMobileDialogValidations';
import PostResponse from 'data/PostResponse';
import { Nullable } from 'features/shared/types/nullable';
import { AlertType } from 'features/shared/alerts/enums/alertType';
import Alert from 'features/shared/alerts/components/Alert';
import { useTranslation } from 'react-i18next';

interface Props {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: (phoneVerification: PhoneNumberVerificationDTO) => void;
  postResponse?: Nullable<PostResponse<string>>;
}

const ConfirmMobileDialog = ({ show, setShow, onSubmit, postResponse }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // form hook
  const { values, setFormValue, errors, bindField, valideteForm } = useForm({
    initialValidations: confirmMobileDialogValidations(),
  });

  // helpers
  const getVerificationDTO = (descriptorCode: string): PhoneNumberVerificationDTO => {
    return {
      descriptorCode: descriptorCode,
      verificationCode: descriptorCode == "TMOVEROVACIKOZADEJ" ? values["verificationCode"] : ""
    };
  }

  // handlers
  const submitFormHandler = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (valideteForm()) {
      let verification = getVerificationDTO("TMOVEROVACIKOZADEJ");
      onSubmit(verification);
    }
  };

  const generateNewCodeHandler = () => {
    let verification = getVerificationDTO("TMOVEROVACIKOD");
    onSubmit(verification);  
    setFormValue("verificationCode", ""); 
  }

  // sub-renders
  const renderResponseAlert = () => {
    if (postResponse) {
      const type: AlertType = postResponse.status < 300 ? "Success" : "Danger";

      return (
        <Alert alertObj={{alertType: type, message: postResponse.data}} className="mb-3" />
      );
    }
  }

  // render
  return (
    <Modal show={show} onHide={() => setShow(false)} backdrop="static">
      <ModalHeader title={tLabels("confirmMobileDialog.cardTitle")} onCloseClick={() => setShow(false)} />
      <form onSubmit={submitFormHandler}>
        <div className="modal-body py-4">
          {renderResponseAlert()}
          <FormGroup labelText={tLabels("confirmMobileDialog.verificationCode")} inputId="verificationCode" validationError={errors["verificationCode"]}>
            <input id="verificationCode" className="form-control" placeholder={tLabels("confirmMobileDialog.setVerificationCodeFromSms")} {...bindField("verificationCode")} />
          </FormGroup>
        </div>
        <ModalFooter>
          <button type="button" className="btn btn-outline-secondary mr-2" onClick={generateNewCodeHandler}>{tLabels("confirmMobileDialog.newCode")}</button>
          <button type="submit" className="btn btn-primary">{tLabels("confirmMobileDialog.send")}</button>
        </ModalFooter>
      </form>
      <PromiseLoadingSpinner area={RequirementDetail_ConfirmMobileDialog} />
    </Modal>
  )
}

export default ConfirmMobileDialog;
